export class TriggerTimeCondition {
  time: string = '';
  type: string = '';
  dayOfWeek?: string = '';
  dayOfMonth?: string = '';
}